import { FormLabel, Stack, Typography } from '@mui/material'
import { useTexts } from '../../useTexts'

export function OrderData() {
  const texts = useTexts()

  return (
    <Stack spacing={2}>
      <FormLabel id="order-data-picker">{texts.orderDataTitle}</FormLabel>
      <Typography variant="body1">{texts.configurationTitle}</Typography>
      <Typography variant="caption" color="text.secondary">
        {texts.configurationDescription}
      </Typography>
    </Stack>
  )
}
